import { Chip } from '@/components/Chip/Chip'
import { Popup } from '@/components/Popup/Popup'
import { TextArea } from '@/components/TextArea/TextArea'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

export const PostFormUI: FunctionalComponent<{
  variants: string[]
  onChange: (variants: string[]) => void
}> = props => {
  const [index, setIndex] = useState(0)

  return (
    <>
      <Popup.Fields>
        <Chip.List>
          {props.variants.map((_, idx) => (
            <Chip
              active={index === idx}
              onClick={() => {
                try {
                  setIndex(idx)
                }
                catch (e) {
                  console.error(e)
                }
              }}
            >
              {idx == 0 ? 'Variant 1' : idx + 1}
            </Chip>
          ))}
        </Chip.List>

        <TextArea
          value={props.variants.at(index)}
          onChange={value => {
            const next = [...props.variants]
            next[index] = value
            props.onChange(next)
          }}
        />
      </Popup.Fields>
    </>
  )
}
